import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
  },
  {
    path: '/dashboard',
    component: () => import('@/views/Dashboard.vue'),
  },
  {
    path: '/setting/work_style',
    name: 'Setting-Workstyle',
    component: () => import('@/views/setting/Workstyle.vue'),
  },
  {
    path: '/setting/users',
    name: 'Setting-Users',
    component: () => import('@/views/setting/Users.vue'),
  },
  {
    path: '/setting/work_manage',
    name: 'Setting-Workmanage',
    component: () => import('@/views/setting/Workmanage.vue'),
  },
  {
    path: '/setting/group',
    name: 'Setting-Group',
    component: () => import('@/views/setting/Group.vue'),
  },
  {
    path: '/setting/alert',
    name: 'Setting-Alert',
    component: () => import('@/views/setting/Alert.vue'),
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('@/views/Account.vue'),
    redirect: '/license',
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue'),
  },
  {
    path: '/help/uninstall',
    name: 'UninstallHelp',
    component: () => import('@/views/UninstallHelp.vue'),
  },
  {
    path: '/help/:article?', // "/help" と "/help/foo" のどちらも許可
    name: 'Help',
    component: () => import('@/views/Help.vue'),
    props: true,
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue'),
  },
  {
    path: '/news/:news_id',
    component: () => import('@/views/News.vue'),
  },
  {
    path: '/alert',
    name: 'AlertList',
    component: () => import('@/views/AlertList.vue'),
  },
  // {
  //   path: '/report/monthly',
  //   name: 'MonthlyReport',
  //   component: () => import('@/views/MonthlyReport.vue'),
  // },
  {
    path: '/Personal',
    name: 'Personal',
    component: () => import('@/parts/app/disp/Personal.vue'),
  },
  {
    path: '/Signup',
  },
  {
    path: '/Login',
  },
  {
    path: '/new',
  },
  {
    path: '/Invoice',
    name: 'Invoice',
    component: () => import('@/parts/app/disp/Invoice.vue'),
  },
  /*
  { // 追加
    path: '/error',
    name: 'サイトエラー',
    component: () => import('@/views/common/Error.vue'),
  },
  */
  {
    path: '/license',
    name: 'License',
    component: () => import('@/views/License.vue'),
  },
  {
    path: '/clientTools',
    name: 'ClientTools',
    component: () => import('@/views/ClientTools.vue'),
  },
  {
    path: '/subscriberInfo',
    name: 'SubscriberInfo',
    component: () => import('@/views/SubscriberInfo.vue'),
  },
  {
    path: '/service/introduction',
    name: 'ServiceIntroduction',
    component: () => import('@/service/Introduction.vue'),
  },
  {
    path: '/service/contact',
    name: 'ServiceContact',
    component: () => import('@/service/Contact.vue'),
  },
  {
    path: '/service/:catchAll(.*)',
    component: () => import('@/parts/app/disp/Welcome.vue'),
  },
  {
    path: '/:catchAll(.*)',
    name: 'Error_404',
    // 存在しないURLの場合、エラー画面（404）に遷移させるため
    // redirect: '/',
    component: () => import('@/views/Error_404.vue'),
  },
];


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
